"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchForLocatorMatch = void 0;
// (C) 2021-2022 GoodData Corporation
var tableDescriptorTypes_1 = require("./tableDescriptorTypes");
var columnWidths_1 = require("../../columnWidths");
var colAccessors_1 = require("./colAccessors");
/**
 * Given data sheet columns, this function will traverse them in order to attempt to match the provided
 * column locators. This function works recursively, if the cols are composite (root col or scope col) then
 * after successfully matching locator, the code proceed further to search through the children.
 *
 * @param cols - columns to search
 * @param locators - column locators to match
 */
function searchForLocatorMatch(cols, locators) {
    var found = undefined;
    var _loop_1 = function (col) {
        if (tableDescriptorTypes_1.isRootCol(col)) {
            // root group is there for better presentation. can be safely skipped during search.
            found = searchForLocatorMatch(col.children, locators);
        }
        else if (tableDescriptorTypes_1.isScopeCol(col)) {
            /*
             * Find attribute locator which matches current scope col's attribute - to compare apples with apples.
             *
             * Once code has that, it can compare the URI of attribute element for which this group was created with
             * the excepted attribute element in the locator.
             */
            var groupByAttributeLocalId_1 = col.attributeDescriptor.attributeHeader.localIdentifier;
            var matchingLocator_1 = locators.find(function (locator) {
                return (columnWidths_1.isAttributeColumnLocator(locator) &&
                    locator.attributeLocatorItem.attributeIdentifier === groupByAttributeLocalId_1);
            });
            if (!columnWidths_1.isAttributeColumnLocator(matchingLocator_1)) {
                return { value: undefined };
            }
            var elementToMatch = matchingLocator_1.attributeLocatorItem.element;
            if (col.header.attributeHeaderItem.uri === elementToMatch) {
                if (locators.length === 1) {
                    // elements match; see if all locators exhausted. if so, it means the width item does
                    // not contain any measure locator; it's OK to match the DataColGroup though, so mark it
                    // as found and bail out
                    found = col;
                }
                else {
                    // otherwise dive deeper to inspect the children. make sure not to send the already-matched locator.
                    var remainingLocators = locators.filter(function (locator) { return locator !== matchingLocator_1; });
                    found = searchForLocatorMatch(col.children, remainingLocators);
                }
            }
        }
        else if (tableDescriptorTypes_1.isSeriesCol(col)) {
            if (locators.length > 1 || !columnWidths_1.isMeasureColumnLocator(locators[0])) {
                return { value: undefined };
            }
            if (colAccessors_1.colMeasureLocalId(col) === locators[0].measureLocatorItem.measureIdentifier) {
                found = col;
            }
        }
        if (found) {
            return { value: found };
        }
    };
    for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
        var col = cols_1[_i];
        var state_1 = _loop_1(col);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return undefined;
}
exports.searchForLocatorMatch = searchForLocatorMatch;
//# sourceMappingURL=colLocatorMatching.js.map